module.exports = __webpack_public_path__ + "img/mind_template_item_4_6.bd3e666e.png";